/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaAlertTriangle2: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="alertTriangle2" viewBox="0 0 22 22">
      <path
        d="M21.0222 18.5776L11.924 2.21448C11.8295 2.06186 11.6977 1.9359 11.5409 1.84854C11.3841 1.76119 11.2076 1.71533 11.0281 1.71533C10.8486 1.71533 10.6721 1.76119 10.5153 1.84854C10.3585 1.9359 10.2266 2.06186 10.1322 2.21448L1.03153 18.5776C0.694197 19.1789 1.18064 19.8903 1.9262 19.8903H20.1275C20.8755 19.8829 21.3595 19.1716 21.0222 18.5776ZM9.88531 7.00071C9.8989 6.70677 10.0252 6.42937 10.2381 6.22616C10.4509 6.02296 10.7338 5.90957 11.0281 5.90957C11.3223 5.90957 11.6053 6.02296 11.8181 6.22616C12.0309 6.42937 12.1573 6.70677 12.1709 7.00071V12.7232C12.1573 13.0171 12.0309 13.2945 11.8181 13.4977C11.6053 13.7009 11.3223 13.8143 11.0281 13.8143C10.7338 13.8143 10.4509 13.7009 10.2381 13.4977C10.0252 13.2945 9.8989 13.0171 9.88531 12.7232V7.00071ZM11.0269 18.1572C10.7507 18.1572 10.4807 18.0752 10.2512 17.9217C10.0216 17.7683 9.84267 17.5501 9.7371 17.2949C9.63153 17.0398 9.60403 16.759 9.65809 16.4882C9.71214 16.2174 9.84532 15.9687 10.0408 15.7735C10.2362 15.5784 10.4851 15.4457 10.7561 15.3921C11.027 15.3385 11.3077 15.3665 11.5627 15.4725C11.8177 15.5786 12.0355 15.7578 12.1886 15.9877C12.3417 16.2176 12.4231 16.4877 12.4226 16.7638C12.4226 16.947 12.3865 17.1284 12.3163 17.2976C12.2462 17.4668 12.1433 17.6205 12.0137 17.7499C11.884 17.8793 11.7301 17.9819 11.5608 18.0518C11.3915 18.1217 11.21 18.1575 11.0269 18.1572Z"
        fill="#9EB3B3"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaAlertTriangle2)
